import { render, staticRenderFns } from "./IconCompetencyHeatmap.vue?vue&type=template&id=025f8109"
import script from "./IconCompetencyHeatmap.vue?vue&type=script&lang=js"
export * from "./IconCompetencyHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports